export const ANALYTICS_DASHBOARD_API_URL = 'ui/partner/analytics';

export const analyticsDashboardQueryKeys = {
  all: [ANALYTICS_DASHBOARD_API_URL],
};
